module.exports = __webpack_public_path__ + "img/lens-160-minus-05.7341206f.png";